

































import { Component, Prop, Vue, Emit } from "vue-property-decorator";
import EmptyDialogComponent from "@/components/common/parts/EmptyDialogComponent.vue";
import ButtonComponent from "@/components/common/parts/ButtonComponent.vue";
import TimepickerComponent from "@/components/packages/timepicker/TimepickerComponent.vue";
import { DisplayTime } from "@/typescript/packages/timepicker/types";
export { DisplayTime };
@Component({
  components: {
    EmptyDialogComponent,
    ButtonComponent,
    TimepickerComponent
  }
})
export default class TimeSetDialogComponent extends Vue {
  defTimeStart: DisplayTime = { HH: "00", mm: "00" };
  defTimeEnd: DisplayTime = { HH: "00", mm: "00" };
  timepickerWidth: string = "85px";
  @Prop({
    default: false
  })
  public display!: boolean;

  @Prop({
    default: ""
  })
  public setTimeStart!: string;

  @Prop({
    default: ""
  })
  public setTimeEnd!: string;

  @Emit()
  changeDefTimeStart(value: DisplayTime) {
    return `${value.HH}:${value.mm}`;
  }

  @Emit()
  changeDefTimeEnd(value: DisplayTime) {
    return `${value.HH}:${value.mm}`;
  }

  @Emit()
  addDefTime(timeStart: DisplayTime, timeEnd: DisplayTime) {
    const addTime = {
      start: `${timeStart.HH}:${timeStart.mm}`,
      end: `${timeEnd.HH}:${timeEnd.mm}`
    };

    return addTime;
  }

  get getDefTimeStart() {
    if (this.setTimeStart) {
      this.defTimeStart.HH =
        this.setTimeStart.substring(0, 2) == "0"
          ? "00"
          : this.setTimeStart.substring(0, 2);
      this.defTimeStart.mm =
        this.setTimeStart.substring(3, 5) == "0"
          ? "00"
          : this.setTimeStart.substring(3, 5);
    }
    return this.defTimeStart;
  }

  get getDefTimeEnd() {
    if (this.setTimeEnd) {
      this.defTimeEnd.HH =
        this.setTimeEnd.substring(0, 2) == "0"
          ? "00"
          : this.setTimeEnd.substring(0, 2);
      this.defTimeEnd.mm =
        this.setTimeEnd.substring(3, 5) == "0"
          ? "00"
          : this.setTimeEnd.substring(3, 5);
    }
    return this.defTimeEnd;
  }
}
